var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.939.382c1.307-.02 2.607-.008 3.905-.02.078 1.485.628 2.997 1.747 4.047 1.117 1.076 2.697 1.568 4.234 1.735v3.905c-1.44-.046-2.888-.337-4.195-.939-.57-.25-1.1-.572-1.619-.902-.006 2.834.012 5.664-.018 8.486a7.244 7.244 0 0 1-1.35 3.823c-1.307 1.86-3.575 3.072-5.904 3.11-1.428.08-2.855-.299-4.072-.996-2.017-1.155-3.437-3.27-3.644-5.539a15.82 15.82 0 0 1-.012-1.443 7.205 7.205 0 0 1 2.58-4.811c1.653-1.4 3.97-2.065 6.14-1.671.02 1.436-.04 2.871-.04 4.308-.99-.311-2.148-.224-3.014.36a3.375 3.375 0 0 0-1.363 1.697c-.207.492-.148 1.038-.136 1.56.238 1.592 1.814 2.93 3.496 2.785 1.116-.012 2.185-.64 2.766-1.56.188-.323.398-.652.41-1.031.098-1.735.059-3.463.07-5.197.009-3.91-.011-7.809.02-11.706h-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 25.725,
    height: 28.175,
    x: 0.55,
    y: 0.363,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 2.45,
    result: "effect1_dropShadow_108_1133"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_1133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_1133",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.37ce66eb74c064c2131dd1626d4c5157.svg";
export { ForwardRef as ReactComponent };